var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMesManagementNoAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 4,
    width: 9,
    height: 13,
    fill: "#FFB400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 4V7H47V4H40ZM38 7V9V12V14V18C38 18.5523 38.4477 19 39 19H48C48.5523 19 49 18.5523 49 18V14V12V9V7V3C49 2.44772 48.5523 2 48 2H39C38.4477 2 38 2.44772 38 3V7ZM47 12V9H40V12H47ZM40 14V17H47V14H40Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 18H46V24H41L41 18Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69231 8.99992C6.08283 8.6094 6.716 8.6094 7.10652 8.99992L21.1064 22.9998H52C53.1046 22.9998 54 23.8953 54 24.9998V55.8934L56.1065 57.9999C56.497 58.3904 56.497 59.0236 56.1065 59.4141C55.716 59.8047 55.0828 59.8047 54.6923 59.4141L5.69231 10.4141C5.30178 10.0236 5.30178 9.39045 5.69231 8.99992ZM27.1066 29L23.1064 24.9998H52V53.8934L36 37.8934V30C36 29.4477 35.5523 29 35 29H27.1066ZM29.1066 31L34 35.8934V31H29.1066ZM48.4717 55.9998L50.4717 57.9998H43H8H3C2.44772 57.9998 2 57.5521 2 56.9998C2 56.4476 2.44772 55.9998 3 55.9998H6V24.9998C6 23.8953 6.89543 22.9998 8 22.9998H15.4717L17.4717 24.9998H8V55.9998H43H48.4717ZM36 46V43.5283L34 41.5283V45H25V32.5283L21.4717 29H13C12.4477 29 12 29.4477 12 30V46C12 46.5523 12.4477 47 13 47H23H25H35C35.5523 47 36 46.5523 36 46ZM14 45V31H23V45H14ZM19 37C19 36.4477 19.4477 36 20 36C20.5523 36 21 36.4477 21 37V39C21 39.5523 20.5523 40 20 40C19.4477 40 19 39.5523 19 39V37ZM28 36C27.4477 36 27 36.4477 27 37V39C27 39.5523 27.4477 40 28 40C28.5523 40 29 39.5523 29 39V37C29 36.4477 28.5523 36 28 36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMesManagementNoAction);
export default __webpack_public_path__ + "static/media/icon-mes-management-no-action.08601e2525b166bcb9e46b852f38ee84.svg";
export { ForwardRef as ReactComponent };